import { h } from 'preact'
import { preventDefault } from '../utils'
import { Text } from 'preact-i18n'

export default ({ items = [], current, onChange }) =>
    <div class="limba__nav-wrap d-none d-md-block">
        <div class="limba__nav container">
            {items.map((item, i) => 
                <div class="limba__nav-tab">
                    <a href="#" class={ item == current ? "active" : "" } onClick={preventDefault(() => onChange(item))}>
                        <Text id={'steps.' + item.name} />
                    </a>
                </div>
            )}
        </div>
    </div>


// WEBPACK FOOTER //
// ./js/components/Tabbar.js